export default "/images/walking-dead-main.jpeg";